import { ISearchResponse } from '@sales-center/common'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get } from '../services/crud'
import { IDivision } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.division}`

export const getDivisions = createAsyncThunk<
  IDivision[],
  void,
  { rejectValue: APIError }
>('divisions/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const payload: ISearchResponse<IDivision> = await response.json()
    return payload.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
